import React from 'react';

export function Slovenia(props) {
  return (
    <svg width="513" height="342" viewBox="0 0 513 342" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0H513V114H0V0Z" fill="white"/>
      <path d="M0 114H513V228H0V114Z" fill="#003DA5"/>
      <path d="M0 228H513V342H0V228Z" fill="#EF3340"/>
      <path d="M50,50 L80,130 L110,50Z" fill="#003DA5"/>
      <circle cx="80" cy="45" r="15" fill="#FFD700"/>
      <circle cx="60" cy="75" r="10" fill="#FFD700"/>
      <circle cx="100" cy="75" r="10" fill="#FFD700"/>
    </svg>
  );
}
